import { useCallback, useEffect, useRef } from "react";

export const usePolling = (pollingFunction: () => unknown, pollingInterval: number): void => {
	const savedCallback = useRef<typeof pollingFunction>(pollingFunction);

	const poll = useCallback(() => savedCallback.current?.(), []);

	useEffect(() => {
		savedCallback.current = pollingFunction;
	}, [pollingFunction]);

	useEffect(() => {
		poll();
	}, [poll]);

	useEffect(() => {
		const intervalId = setInterval(poll, pollingInterval);

		return () => clearInterval(intervalId);
	}, [pollingInterval, poll]);
};
